import { t } from 'i18next';
import { Button, SquareBadge } from '@peacecover/component';
import { useGetBettieBalances } from '../../../domains/bettie/ui/hooks/useGetBettieBalances';
import { useGetMySubscription } from '../../../domains/payments/ui/hooks/useGetMySubscription';
import { ReactComponent as LikeIcon } from '../../../icons/likeGradientShape.svg';
import { isEmpty } from 'lodash';
import { daysUntil } from '../../../utils/DateUtil';

interface BettieCreditBannerProps {
  setIsChargeBottomSheetOpen: (isOpen: boolean) => void;
}
const BettieCreditBanner = ({ setIsChargeBottomSheetOpen }: BettieCreditBannerProps) => {
  const { data: mySubscription } = useGetMySubscription();

  const getSubscriptionBadges = () => {
    if (isEmpty(mySubscription)) {
      return null;
    }

    const productType = mySubscription.productType === 'standard' ? '스탠다드' : '프리미엄';
    if (mySubscription.canceledAt) {
      const cancelDday = daysUntil(mySubscription.nextBillingDate);
      return (
        <div className="flex items-center gap-[4px]">
          <SquareBadge colorVariant="secondary" className="text-text-primary">
            {t('BettieChatList.toBeCancel', { product: productType })}
          </SquareBadge>
          <SquareBadge className="bg-surface-lv2">
            {t('BettieChatList.expirationDate', { day: cancelDday ?? '-' })}
          </SquareBadge>
        </div>
      );
    }

    const nextBillingDday = daysUntil(mySubscription.nextBillingDate);
    return (
      <div className="flex items-center gap-[4px]">
        <SquareBadge colorVariant="secondary" className="text-text-primary">
          {t('BettieChatList.useSubscription', { product: productType })}
        </SquareBadge>
        <SquareBadge className="bg-surface-lv2">
          {t('BettieChatList.nextBillingDay', { day: nextBillingDday ?? '-' })}
        </SquareBadge>
      </div>
    );
  };

  return (
    <div className="bg-[linear-gradient(102deg,#860EFF_0%,#2DE7D1_44%,#C855FF_100%)] p-[1px] rounded-[15px] shadow-[0_0_2px_0_rgba(0,0,0,0.05),_0_0_10px_0_rgba(0,0,0,0.08)]">
      <div className="bg-background-light dark:bg-background-elevated rounded-[14px] flex items-center justify-between px-[18px] py-[17px]">
        <div className="flex flex-col items-start gap-[11px]">
          <BettieChatCount />
          {getSubscriptionBadges()}
        </div>
        <Button
          size="small"
          className="text-[13px] font-medium leading-[16px] px-[12px]"
          onClick={() => setIsChargeBottomSheetOpen(true)}
        >
          {t('BettieChatList.purchase')}
        </Button>
      </div>
    </div>
  );
};

export default BettieCreditBanner;

export const BettieChatCount = ({
  className = '',
  textClassName = ''
}: {
  className?: string;
  textClassName?: string;
}) => {
  const { data: bettieBalances, isLoading } = useGetBettieBalances();

  return (
    <div className={`flex items-center gap-[4px] ${className}`}>
      <LikeIcon width={16} height={16} />
      <p className="text-[15px] font-bold leading-[18px] bg-gradient-to-r from-[#FF45A9] to-[#FF6A6A] bg-clip-text text-transparent">
        {isLoading ? '-' : (bettieBalances?.bettiePoint?.balance ?? 0)}개
      </p>
      <p className={`text-[12px] text-text-main-lv3 leading-[14px] ${textClassName}`}>
        {t('BettieChatList.enabledChatCount')}
      </p>
    </div>
  );
};
